// Telemetry must initialize before any component code
import { reactPlugin } from './services/telemetry'
import { AppInsightsContext, AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import App from './App.jsx'
import AdminApp from './AdminApp.jsx'
import OutlookApp from './OutlookApp.jsx'
import './index.css'

function ErrorFallback() {
  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center">
      <div className="text-center p-8">
        <h1 className="text-2xl font-bold text-white mb-4">Something went wrong</h1>
        <p className="text-slate-400 mb-6">An unexpected error occurred. Please try reloading the page.</p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2 bg-amber-600 hover:bg-amber-500 text-white rounded-lg transition-colors"
        >
          Reload Page
        </button>
      </div>
    </div>
  )
}

function renderApp() {
  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <AppInsightsContext.Provider value={reactPlugin}>
        <AppInsightsErrorBoundary onError={ErrorFallback}>
          {window.location.hostname === 'po-processor-app-dev.atlanticpkg.com' && (
              <div className="bg-amber-600 text-white text-center text-sm font-semibold py-1">
                Development Environment
              </div>
            )}
          <BrowserRouter>
            <Routes>
              <Route path="/outlook/*" element={<OutlookApp />} />
              <Route path="/admin/*" element={<AdminApp />} />
              <Route path="*" element={<App />} />
            </Routes>
          </BrowserRouter>
        </AppInsightsErrorBoundary>
      </AppInsightsContext.Provider>
    </React.StrictMode>,
  )
}

if (window.location.pathname.startsWith('/outlook')) {
  // Outlook routes: wait for Office.js to fully initialize before rendering
  Office.onReady(() => renderApp())
} else {
  // All other routes: render immediately
  // (Office.js may throw errors outside Outlook context but we don't need it)
  renderApp()
}
